import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { NgForm } from '@angular/forms/src/directives/ng_form';
import { Proxy } from '../../services/proxy/proxy.service';

@IonicPage()
@Component({
  selector: 'page-modal-dorsal',
  templateUrl: 'modal-dorsal.html',
})
export class ModalDorsalPage {

  //#region Propiedades del controlador
  public alineado: Proxy.PrPersonaAlineable = undefined;
  public dorsal: number = 0;
  //#endregion

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private viewCtrl: ViewController) {
  }

  ionViewDidLoad() {
    this.alineado = <Proxy.PrPersonaAlineable>this.navParams.get("alineado");
    this.dorsal = <number>this.navParams.get("dorsal");
  }

  //#region Métodos del controlador

  public Actualizar(form:NgForm):void{
    if (form.valid){
      this.viewCtrl.dismiss(this.dorsal);
    }
  }

  //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/modal-dorsal/modal-dorsal.ts